
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { BcDocumentType } from 'enums/BcDocumentType';
import { Model, ModelProperty } from 'models/Model';


export class CustomerLedgerEntryModel extends Model<CustomerLedgerEntryModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'entryNo', type: 'number', languageString: 'customerLedgerEntry.property.entryNo' },
		{ name: 'customerNo', type: 'string', languageString: 'customerLedgerEntry.property.customerNo' },
		{ name: 'postingDate', type: 'Date', languageString: 'customerLedgerEntry.property.postingDate' },
		{ name: 'documentType', type: 'BcDocumentType', languageString: 'customerLedgerEntry.property.documentType' },
		{ name: 'documentNo', type: 'string', languageString: 'customerLedgerEntry.property.documentNo' },
		{ name: 'description', type: 'string', languageString: 'customerLedgerEntry.property.description' },
		{ name: 'currencyCode', type: 'string', languageString: 'customerLedgerEntry.property.currencyCode' },
		{ name: 'dimensionCode1Product', type: 'string', languageString: 'customerLedgerEntry.property.dimensionCode1Product' },
		{ name: 'dimensionCode2Department', type: 'string', languageString: 'customerLedgerEntry.property.dimensionCode2Department' },
		{ name: 'amount', type: 'number', languageString: 'customerLedgerEntry.property.amount' },
		{ name: 'amountInclVat', type: 'number', languageString: 'customerLedgerEntry.property.amountInclVat' },
		{ name: 'remainingAmount', type: 'number', languageString: 'customerLedgerEntry.property.remainingAmount' },
		{ name: 'remainingAmountInclVat', type: 'number', languageString: 'customerLedgerEntry.property.remainingAmountInclVat' },
		{ name: 'open', type: 'boolean', languageString: 'customerLedgerEntry.property.open' },
		{ name: 'dueDate', type: 'Date', languageString: 'customerLedgerEntry.property.dueDate' },
		{ name: 'onHold', type: 'string', languageString: 'customerLedgerEntry.property.onHold' },
		{ name: 'externalDocumentNo', type: 'string', languageString: 'customerLedgerEntry.property.externalDocumentNo' }
	];
	[key: string]: any;
	
	public entryNo?: number;
	public customerNo: string;
	public postingDate?: Date;
	public documentType: BcDocumentType;
	public documentNo: string;
	public description: string;
	public currencyCode: string;
	public dimensionCode1Product: string;
	public dimensionCode2Department: string;
	public amount?: number;
	public amountInclVat?: number;
	public remainingAmount?: number;
	public remainingAmountInclVat?: number;
	public open?: boolean;
	public dueDate?: Date;
	public onHold: string;
	public externalDocumentNo: string;
    
	constructor(){
		super();
		this.entryNo = undefined;
		this.customerNo = '';
		this.postingDate = undefined;
		this.documentType = 0;
		this.documentNo = '';
		this.description = '';
		this.currencyCode = '';
		this.dimensionCode1Product = '';
		this.dimensionCode2Department = '';
		this.amount = undefined;
		this.amountInclVat = undefined;
		this.remainingAmount = undefined;
		this.remainingAmountInclVat = undefined;
		this.open = undefined;
		this.dueDate = undefined;
		this.onHold = '';
		this.externalDocumentNo = '';
		
	}
	getProperties(){
		return CustomerLedgerEntryModel.classProperties;
	}
}

